export default {
    GET_PRODUCTS: "getDevices",
    GET_CATEGORY: "getCategory",
    UPDATE_PAGE_NUMBER: "updatePageNumber",
    SELECT_DEVICE: "selectDevice",
    UPDATE_SELECTED_COLOR: "updateSelectedColor",
    SET_FILTERED_PRODUCTS: "setFilteredProducts",
    PRODUCT_SUMMARY: "getProductSummary",
    GOTO_SHOPPING_CART: "goToShoppingCart",
};
